module.exports = function() {
  return new Worker(__webpack_public_path__ + "9703da303c3bc332022c.worker.js");
};